import { Tkv2ReferenceBarProperty } from '../../controller/types.js';
import { ReferenceViewIDParsed, formatReferenceViewID } from '../referenceView/index.js';

export const getReferenceProperty = (
  column: 'subject' | string,
  compSeq: string[],
): Tkv2ReferenceBarProperty => {
  const id: ReferenceViewIDParsed =
    column === 'subject' ? { type: 'subject' } : { type: 'comparable', compID: column };
  return {
    id: formatReferenceViewID(id),
    mapPinLabel: column === 'subject' ? '' : (compSeq.indexOf(column) + 1).toFixed(0),
  };
};
